export default __webpack_public_path__ + "static/media/Ellipse 90.a005d801.png";